import { Subject } from 'rxjs';
import { CrimeEvent } from '../interfaces/CrimeEvent';
import { WantedLevelService } from './WantedLevelService';

const LEVEL_INCREASE_COOLDOWN_MS = 10_000;

export class CrimeDetectionService {
    public readonly crime$ = new Subject<CrimeEvent>();
    private lastLevelIncreaseAt = 0;

    constructor(private readonly wantedLevelService: WantedLevelService) {}

    reportCrime(event: CrimeEvent): void {
        this.crime$.next(event);

        const now = Date.now();
        if (now - this.lastLevelIncreaseAt >= LEVEL_INCREASE_COOLDOWN_MS) {
            this.lastLevelIncreaseAt = now;
            this.wantedLevelService.increase();
        }
    }
}
